//@flow
import * as React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';
import { IconWithPopover } from 'common/components/core/icon';

import theme from './ListWithHeader.scss';

type Props = {
    theme: Object,
    leftIcon?: any,
    rightIcon?: any,
    title: string,
    children?: React.Element<any>,
    className?: string,
    onListClose: () => void
};
const DefaultLeftIcon = ({ leftIcon }) => {
    return leftIcon ? leftIcon : null;
};

const DefaultRightIcon = ({ rightIcon }) => {
    return rightIcon ? rightIcon : null;
};

const listWithHeaderFactory = ({
    LeftIcon = DefaultLeftIcon,
    RightIcon = DefaultRightIcon
}) => {
    class ListWithHeader extends React.PureComponent<Props, void> {
        render() {
            const {
                theme,
                leftIcon,
                rightIcon,
                title,
                children,
                onListClose,
                className,
                ...others
            } = this.props;

            return (
                <div className={classnames(theme.listWrapper, className)}>
                    <div className={theme.listHeader}>
                        <div className={theme.left}>
                            {leftIcon ? (
                                <div className={theme.icon}>
                                    <LeftIcon
                                        leftIcon={leftIcon}
                                        theme={theme}
                                        {...others}
                                    />
                                </div>
                            ) : null}
                            <div className={theme.text}>{title}</div>
                        </div>
                        <div className={theme.right}>
                            <RightIcon
                                rightIcon={rightIcon}
                                theme={theme}
                                {...others}
                            />
                            {onListClose ? (
                                <IconWithPopover
                                    theme={theme}
                                    className={theme.closeBtn}
                                    icon="cancel-thin"
                                    onClick={onListClose}
                                />
                            ) : null}
                        </div>
                    </div>
                    <div className={theme.listWrap}>{children}</div>
                </div>
            );
        }
    }
    return themr('ListWithHeader', theme)(ListWithHeader);
};

const ListWithHeader = listWithHeaderFactory({});
export { ListWithHeader, listWithHeaderFactory };
export default ListWithHeader;
